import { Context, Module } from 'vuex-smart-module';
import { WriteupState } from '@/store/writeup/state';
import { WriteupGetters } from '@/store/writeup/getters';
import { WriteupMutations } from '@/store/writeup/mutations';
import { WriteupActions } from '@/store/writeup/actions';

export type WriteupModuleContext = Context<Module<WriteupState, WriteupGetters, WriteupMutations, WriteupActions>>;

export const writeupModule = new Module({
	state: WriteupState,
	getters: WriteupGetters,
	mutations: WriteupMutations,
	actions: WriteupActions,
});
